import React from "react";
import styles from "../../../../UCC/reports/detailReport/detailReport.module.scss";
import strings from "../../../../../../../../strings";
import Button from "../../../../../../../shared/Button";
import PrepareTooltip from "components/shared/Tooltip/index";
import { DropdownButton } from 'react-bootstrap';
import DropdownItem from 'react-bootstrap/esm/DropdownItem';
import AuthService from "../../../../../../../../tools/AuthService";


const FilingDetailsContainerTitle = ({selectedFilings, setDocumentRequest, handleSort}) => {

    const requestDocumentsDisabled = selectedFilings.length === 0;
    const { isReadOnlyUser } = AuthService.getClientFeatures()

    return (
        <div className={styles.filingsContainer}>
            <h4 className='mb-0'>{strings.APPLICANT.UCC.FILINGS}</h4>
            <div className="d-flex gap-2">
            <div className='d-flex justify-content-end align-items-center'>
                <DropdownButton
                    title={strings.APPLICANT.UCC.SORT_BY}
                    onSelect={handleSort}
                    variant='text rounded-pill'
                    color='#2627FC'
                >
                    <DropdownItem eventKey="all">
                        {strings.APPLICANT.UCC.SHOW_ALL}
                    </DropdownItem>
                    <DropdownItem eventKey="recent">
                        {strings.APPLICANT.UCC.MOST_RECENT}
                    </DropdownItem>
                    <DropdownItem eventKey="active">
                        {strings.APPLICANT.UCC.ACTIVE_FILINGS}
                    </DropdownItem>
                </DropdownButton>

            </div>
            {!isReadOnlyUser &&
                <PrepareTooltip title={requestDocumentsDisabled ? strings.APPLICANT.UCC.SELECT_DOCUMENTS_TO_REQUEST : ''} theme='white'>
                    <Button
                        variant="outlined"
                        color="primary"
                        className='summaryHeaderButton ml-3'
                        onClick={() => setDocumentRequest(true)}
                        disabled={requestDocumentsDisabled}
                    >
                        {strings.APPLICANT.UCC.REQUEST_DOCUMENTS}
                    </Button>
                </PrepareTooltip>
            }
            </div>
        </div>
    )
}

export default FilingDetailsContainerTitle;